import { LabelValueTextProps } from '@components/LabelValueText/LabelValueText';
import { NomineeCustomer } from '@features/api/response/NomineeCustomer';
import GlobalIntlSingleton from '@setup/intl/GlobalIntlSingleton';
import { Theme } from '@mui/material';
import { PersonalDetailsForm } from './EditForms/PersonalDetailsForm/PersonalDetailsForm';
import { CategorizedDataForm } from './EditForms/CategorizedDataForm/CategorizedDataForm';

export enum SliderTypes {
  EditPersonalDetails = 'Edit personal details',
}

export const SliderComponents = (
  sliderType: SliderTypes | string | undefined,
  customer: NomineeCustomer,
  onClose: () => void
) => {
  if (!sliderType) return null;

  switch (sliderType) {
    case SliderTypes.EditPersonalDetails: {
      return <PersonalDetailsForm customer={customer} onSave={onClose} />;
    }
    default: {
      return (
        <CategorizedDataForm
          categoryName={sliderType}
          customer={customer}
          onSave={onClose}
          onEditCategoryName={onClose}
        />
      );
    }
  }
};

export const getPersonalInfo = (
  customer: NomineeCustomer,
  theme: Theme
): LabelValueTextProps[] => {
  return [
    {
      label: GlobalIntlSingleton.intl.formatMessage({
        id: 'crm.id',
      }),
      value: customer.id,
    },
    {
      label: GlobalIntlSingleton.intl.formatMessage({
        id: 'crm.firstName',
      }),
      value: customer.firstName,
    },
    {
      label: GlobalIntlSingleton.intl.formatMessage({
        id: 'crm.middleName',
      }),
      value: customer.middleName,
    },
    {
      label: GlobalIntlSingleton.intl.formatMessage({
        id: 'crm.lastName',
      }),
      value: customer.lastName,
    },
  ];
};
